import React, { useEffect, useState } from 'react'
import Cookie from 'js-cookie'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const COOKIE_KEY = 'premiumkey-store-warning-dismissed'

const PremiumKeyWarning = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (Cookie.get(COOKIE_KEY) !== 'true') {
      setIsOpen(true)
    }
  }, [])

  const handleAcknowledge = () => {
    Cookie.set(COOKIE_KEY, 'true', { expires: 1 })
    setIsOpen(false)
  }

  return (
    <Modal isOpen={isOpen} backdrop="static" keyboard={false}>
      <ModalHeader className="text-danger">
        <i className="fas fa-exclamation-triangle text-danger mr-2"></i>
        Attention: Fraud Warning
      </ModalHeader>
      <ModalBody>
        <p className="mb-3">
          <strong>
            Do NOT purchase premium keys from{' '}
            <span className="text-danger">Premiumkey.store</span> website.
          </strong>
        </p>
        <p className="mb-3">
          We have received complaints from several users that fake premium keys
          have been shared by them. Please buy your premium keys only from
          official sources listed on our website to avoid being scammed.
        </p>
        <p className="mb-0 text-danger">
          <strong>Note:</strong> If you purchase premium keys from them, we will
          not be liable or responsible for any loss or issues arising from it.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleAcknowledge}>
          I understand
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PremiumKeyWarning
